"use strict";
import { UniverseChainId } from "features/chains/types";
import {
  arbitrum,
  avalanche,
  base,
  mainnet,
  optimism,
  polygon
} from "viem/chains";
export const ZERO_X_NATIVE_TOKEN = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
export const BRIDGE_DEFAULT_SLIPPAGE = 1;
export const BRIDGE_BNB_CHAIN_ID = UniverseChainId.Mainnet;
export const BRIDGE_CHAINS = [
  {
    id: BRIDGE_BNB_CHAIN_ID,
    name: "BNB Chain",
    shortName: "BNB",
    nativeSymbol: "BNB",
    nativeName: "BNB",
    nativeDecimals: 18,
    logoUrl: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/info/logo.png",
    blockExplorerUrl: "https://bscscan.com",
    priceChainKey: "bsc",
    nativePriceId: "binancecoin",
    walletSwitchable: true,
    nativeGasReserve: 2e-3
  },
  {
    id: 1,
    name: "Ethereum",
    shortName: "Ethereum",
    nativeSymbol: "ETH",
    nativeName: "Ether",
    nativeDecimals: 18,
    logoUrl: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png",
    blockExplorerUrl: "https://etherscan.io",
    priceChainKey: "ethereum",
    nativePriceId: "ethereum",
    walletSwitchable: true,
    nativeGasReserve: 0.01
  },
  {
    id: 42161,
    name: "Arbitrum",
    shortName: "Arbitrum",
    nativeSymbol: "ETH",
    nativeName: "Ether",
    nativeDecimals: 18,
    logoUrl: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/arbitrum/info/logo.png",
    blockExplorerUrl: "https://arbiscan.io",
    priceChainKey: "arbitrum",
    nativePriceId: "ethereum",
    walletSwitchable: true,
    nativeGasReserve: 8e-4
  },
  {
    id: 8453,
    name: "Base",
    shortName: "Base",
    nativeSymbol: "ETH",
    nativeName: "Ether",
    nativeDecimals: 18,
    logoUrl: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/base/info/logo.png",
    blockExplorerUrl: "https://basescan.org",
    priceChainKey: "base",
    nativePriceId: "ethereum",
    walletSwitchable: true,
    nativeGasReserve: 8e-4
  },
  {
    id: 10,
    name: "Optimism",
    shortName: "Optimism",
    nativeSymbol: "ETH",
    nativeName: "Ether",
    nativeDecimals: 18,
    logoUrl: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/optimism/info/logo.png",
    blockExplorerUrl: "https://optimistic.etherscan.io",
    priceChainKey: "optimism",
    nativePriceId: "ethereum",
    walletSwitchable: true,
    nativeGasReserve: 8e-4
  },
  {
    id: 137,
    name: "Polygon",
    shortName: "Polygon",
    nativeSymbol: "POL",
    nativeName: "Polygon",
    nativeDecimals: 18,
    logoUrl: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png",
    blockExplorerUrl: "https://polygonscan.com",
    priceChainKey: "polygon",
    nativePriceId: "matic-network",
    walletSwitchable: true,
    nativeGasReserve: 0.1
  },
  {
    id: 43114,
    name: "Avalanche",
    shortName: "Avalanche",
    nativeSymbol: "AVAX",
    nativeName: "Avalanche",
    nativeDecimals: 18,
    logoUrl: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/avalanchec/info/logo.png",
    blockExplorerUrl: "https://snowtrace.io",
    priceChainKey: "avax",
    nativePriceId: "avalanche-2",
    walletSwitchable: true,
    nativeGasReserve: 0.02
  }
];
export const BRIDGE_CHAINS_BY_ID = Object.fromEntries(
  BRIDGE_CHAINS.map((chain) => [chain.id, chain])
);
export function getBridgeChain(chainId) {
  return BRIDGE_CHAINS_BY_ID[chainId];
}
export const BRIDGE_WAGMI_CHAINS = [
  { ...arbitrum, rpcUrls: { default: { http: ["https://arbitrum-one-rpc.publicnode.com"] } } },
  { ...base, rpcUrls: { default: { http: ["https://base-rpc.publicnode.com"] } } },
  { ...optimism, rpcUrls: { default: { http: ["https://optimism-rpc.publicnode.com"] } } },
  { ...polygon, rpcUrls: { default: { http: ["https://polygon-bor-rpc.publicnode.com"] } } },
  // Re-export ETH/AVAX/Mainnet with CORS-friendly RPCs in case the app config
  // ordering changes; deduped by id when merged into the wagmi config.
  { ...mainnet, rpcUrls: { default: { http: ["https://ethereum-rpc.publicnode.com"] } } },
  { ...avalanche, rpcUrls: { default: { http: ["https://avalanche-c-chain-rpc.publicnode.com"] } } }
];
